import React from 'react';
import { useSearchParams, Navigate } from 'react-router-dom';
import { useAuth } from './context';
import { LoadingState } from './ui';
import { AuthIntro } from './auth/AuthIntro';
import { LoginForm, RegisterForm } from './auth/AccountForms';

export default function Auth() {
  const [params, setParams] = useSearchParams();
  const { user, loading } = useAuth();
  const register = params.get('mode') === 'register';
  if (loading) return <LoadingState />;
  if (user) return <Navigate to="/workspace" replace />;

  return <div className="container auth-layout">
    <AuthIntro />
    <section className="auth-form">
      <div className="auth-tabs">
        <button data-testid="auth-login-tab" className={!register ? 'active' : ''} onClick={() => setParams({})}>Sign in</button>
        <button data-testid="auth-register-tab" className={register ? 'active' : ''}
          onClick={() => setParams({ mode: 'register' })}>Create business account</button>
      </div>
      <h2>{register ? 'Let’s meet your business.' : 'Welcome back.'}</h2>
      <p>{register ? 'Your application will be reviewed before trading access is enabled.' : 'Sign in to your SuperHub workspace.'}</p>
      {register ? <RegisterForm key={params.get('role') || 'buyer'} initialRole={params.get('role')} /> : <LoginForm />}
    </section>
  </div>;
}